import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { setFingerprint } from '../../store/actions/affiliate/afilliateActions';
import useScript from '../../util/hooks/useScript';

const PrepareRegistration = () => {
  const dispatch = useDispatch();
  const referrerUrl = document.referrer;

  useScript(
    'https://portalcontenthaaregistration.s3.amazonaws.com/staging/v0030/Scripts/vendors/fingerprint2.js',
  );

  useEffect(() => {
    if (referrerUrl) {
      window.Fingerprint2?.get((components) => {
        const values = components.map((component) => component.value);
        const fingerPrint = window.Fingerprint2.x64hash128(values.join(''), 31);
        dispatch(
          setFingerprint({
            Fp: fingerPrint,
            UrlReferrer: referrerUrl,
          }),
        );
      });
    }
  }, [referrerUrl, dispatch]);

  return null;
};

export default PrepareRegistration;
